import { render, staticRenderFns } from "./RevokeVerificationModal.vue?vue&type=template&id=21010d7c&scoped=true&"
import script from "./RevokeVerificationModal.vue?vue&type=script&lang=js&"
export * from "./RevokeVerificationModal.vue?vue&type=script&lang=js&"
import style0 from "./RevokeVerificationModal.vue?vue&type=style&index=0&lang=css&"
import style1 from "./RevokeVerificationModal.vue?vue&type=style&index=1&id=21010d7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21010d7c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4282463623/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21010d7c')) {
      api.createRecord('21010d7c', component.options)
    } else {
      api.reload('21010d7c', component.options)
    }
    module.hot.accept("./RevokeVerificationModal.vue?vue&type=template&id=21010d7c&scoped=true&", function () {
      api.rerender('21010d7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/NewUI/components/customer/authorizations/revoke/RevokeVerificationModal.vue"
export default component.exports